import "../../App.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import UserTab from "../UserTab";
import CurrentUser from "../CurrentUser";
import Parametros from "../Parametros";

const REPORT_ENDPOINT = "reports/carga_gestiones_autofin";
const REPORT_EXCEL_ENDPOINT = "reports/carga_gestiones_autofin/excel";
const PREVIEW_LIMIT = 50;

function Autofin() {
  const [usuario] = useState(CurrentUser.user);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetch(Parametros.urlApi + REPORT_ENDPOINT, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const detail = await res.text();
          throw new Error(detail || "Error al cargar el reporte");
        }
        return res.json();
      })
      .then((rows) => {
        const safe = Array.isArray(rows) ? rows : [];
        setData(safe);
        setColumns(safe.length > 0 ? Object.keys(safe[0]) : []);
      })
      .catch((e) => {
        console.error(e);
        setError("No se pudo cargar el reporte. Intentalo nuevamente.");
      })
      .finally(() => setLoading(false));
  }, [usuario.key]);

  const handleExport = async () => {
    setExporting(true);
    try {
      const res = await fetch(Parametros.urlApi + REPORT_EXCEL_ENDPOINT, {
        method: "GET",
        headers: { Authorization: "Bearer " + usuario.key },
      });
      if (!res.ok) {
        throw new Error("Error al exportar el reporte");
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      link.href = url;
      link.download = `carga_gestiones_autofin_${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      alert(e.message || "Error al exportar a Excel");
    } finally {
      setExporting(false);
    }
  };

  const previewRows = data.slice(0, PREVIEW_LIMIT);

  const formatCell = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
  };

  return (
    <div className="App">
      <Sidebar tipo="3" />
      <br />
      <UserTab nombre={"Asignación Autofin"} />
      <div className="container">
        <div className="col-md-12" style={{ marginTop: 16 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
              marginBottom: 16,
            }}
          >
            <div>
              <h3 style={{ margin: 0 }}>Carga de Gestiones — Autofin</h3>
              <small style={{ color: "#6b6b6b" }}>
                Fuente: <code>v_carga_gestiones_autofin</code>
                {data.length > 0 && (
                  <> · {data.length} registro{data.length === 1 ? "" : "s"}</>
                )}
                {data.length > PREVIEW_LIMIT && (
                  <> (vista previa: primeras {PREVIEW_LIMIT})</>
                )}
              </small>
            </div>
            <button
              type="button"
              onClick={handleExport}
              disabled={exporting || loading || data.length === 0}
              className="btn btn-primary"
              style={{ minWidth: 200 }}
            >
              {exporting ? "Exportando..." : "Exportar a Excel"}
            </button>
          </div>

          {error && (
            <div className="alert alert-danger" style={{ marginBottom: 16 }}>
              {error}
            </div>
          )}

          <div
            className="table-responsive"
            style={{ maxHeight: "60vh", overflow: "auto" }}
          >
            <table
              className="table table-bordered table-hover"
              style={{ background: "#fff", marginBottom: 0 }}
            >
              <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col}
                      style={{
                        background: "#6B5B95",
                        color: "#fff",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td
                      colSpan={Math.max(columns.length, 1)}
                      style={{ textAlign: "center", padding: 24 }}
                    >
                      Cargando reporte...
                    </td>
                  </tr>
                )}
                {!loading && previewRows.length === 0 && (
                  <tr>
                    <td
                      colSpan={Math.max(columns.length, 1)}
                      style={{ textAlign: "center", padding: 24 }}
                    >
                      Sin datos para mostrar.
                    </td>
                  </tr>
                )}
                {!loading &&
                  previewRows.map((row, idx) => (
                    <tr key={idx}>
                      {columns.map((col) => (
                        <td key={col} style={{ whiteSpace: "nowrap" }}>
                          {formatCell(row[col])}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Autofin);
